import { EUserFlow } from '@/context/borrower';
import { EDisplays, EJourneys } from '@/context/display';
import { IPartnerParams } from '@/partners/partnerTypes';
import { EParameters } from '@/utils/setParametersFromParams';

import { getCaseInsensitiveParam } from '../getCaseInsensitiveParam';

import { ISetInitialDisplay } from './ISetInitialDisplay';

export function getInitialDisplayData(
    partner: IPartnerParams,
    params: URLSearchParams
): ISetInitialDisplay {
    const paramJourney = getCaseInsensitiveParam(
        params,
        EParameters.INITIAL_JOURNEY
    );
    const testDriveFlow = getCaseInsensitiveParam(
        params,
        EParameters.TEST_DRIVE_FLOW
    );
    let initialJourney = EJourneys.FINANCE;
    let userFlow = partner.userFlow;

    // Check for test drive flow parameter first
    if (testDriveFlow === 'true' || testDriveFlow === '1') {
        initialJourney = EJourneys.TEST_DRIVE;
        userFlow = EUserFlow.TEST_DRIVE;
    } else if (
        paramJourney?.toLowerCase() === 'test_drive' ||
        paramJourney?.toUpperCase() === 'TEST_DRIVE'
    ) {
        initialJourney = EJourneys.TEST_DRIVE;
        userFlow = EUserFlow.TEST_DRIVE; // Override userFlow for test drive journey
    }

    return {
        showWelcomeScreen: {
            parameter: getCaseInsensitiveParam(
                params,
                EParameters.SHOW_WELCOME_SCREEN
            ),
            partner: partner.welcomeScreen,
        },
        isWhiteLabel: partner.whiteLabel,
        logo: {
            parameter: getCaseInsensitiveParam(params, EParameters.LOGO_URL),
            partner: partner.logo,
        },
        type: partner.type,
        termsAndConditionsLink: partner.termsAndConditionsLink,
        askTermsAndConditions: getCaseInsensitiveParam(
            params,
            EParameters.TERMS_AND_CONDITIONS
        ),
        hideVehicleScreen: partner.hideSelectVehicleScreen,
        hideSellerScreen: partner.hideSellerScreen,
        waterfallLenders: partner.waterfallLenders,
        makeSpecificLenders: partner.makeSpecificLenders,
        paramCustomWaterfallId: getCaseInsensitiveParam(
            params,
            EParameters.CUSTOM_WATERFALL_ID
        ),
        showTotalAmountPayable: partner.showTotalAmountPayable,
        name: {
            parameter: getCaseInsensitiveParam(params, EParameters.DEALER_NAME),
            partner: partner.dealerName,
        },
        email: {
            parameter: getCaseInsensitiveParam(params, EParameters.EMAIL),
            partner: partner.dealerEmail,
        },
        phone: {
            parameter: getCaseInsensitiveParam(params, EParameters.PHONE),
            partner: partner.dealerPhone,
        },
        colors: {
            parameterPrimaryColor: getCaseInsensitiveParam(
                params,
                EParameters.PRIMARY_COLOR
            ),
            parameterSecondaryColor: getCaseInsensitiveParam(
                params,
                EParameters.SECONDARY_COLOR
            ),
            parameterTertiaryColor: getCaseInsensitiveParam(
                params,
                EParameters.TERTIARY_COLOR
            ),
            parameterQuaternaryColor: getCaseInsensitiveParam(
                params,
                EParameters.QUATERNARY_COLOR
            ),

            partnerPrimaryColor: partner.primaryColor,
            partnerSecondaryColor: partner.secondaryColor,
            partnerTertiaryColor: partner.tertiaryColor,
            partnerQuaternaryColor: partner.quaternaryColor,
        },
        partnerId: partner.id,
        partner: partner,
        display: getCaseInsensitiveParam(
            params,
            EParameters.SCREEN
        ) as EDisplays, // TODO: add check here
        lenderSorting: partner.lenderSorting,
        sendLeadEmail: partner.sendLeadEmail,
        availableVehicleAssetTypes: partner.availableVehicleAssetTypes,
        requireGlassGuide: partner.requireGlassGuide,
        illionCodes: partner.illionCodes,
        initialJourney,
        partnerMakeWaterfallIdOverwrite: partner.makeWaterfallIdOverwrite,
        paramQrScanwareId: getCaseInsensitiveParam(
            params,
            EParameters.QR_SCANWARE_ID
        ),
        // widgetId = first URL path segment (e.g. /abbey → 'abbey', /m3565 → 'm3565').
        // Query params like ?amount=10000 are ignored for this extraction.
        widgetId:
            window.location.pathname.split('/').filter(Boolean)[0] ?? null,
        userFlow,
        stockIntegration: partner.stockIntegration,
    };
}
